import React from "react";
import "../../component/events_page/event_detail_page.css";
// import calendarImg from "../../parm_assets/";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const apc = "https://ik.imagekit.io/axiomhives/parm_assets/PRESS-RELEASE-TREE-FAILURE-INCIDENT-Final_page-0001-1-1024x1448.jpg"
const NewsDetailPage = () => {

  return (
    <section className="explore-events-detail-section">
      <div className="explore-events-detail-content">
         <div className="explore-events-detail-image">
          <Zoom>
          <img src={apc} alt="Calendar of Events" className="apc_poster"/>
          </Zoom>
        </div>

      </div>
    </section>
  );
};

export default NewsDetailPage;
